/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { shaka as Shaka } from './shaka';

declare global {
  interface Window {
    debug: {
      shaka: typeof Shaka;
    };
  }
}

const debug = {
  shaka: Shaka,
};

export function initDebug() {
  window.debug = debug;
}
